import { EventEntity } from '../schema/EventEntity';
import { EventsCache } from 'owa-events-cache';

export function replaceEvents<T extends EventEntity>(eventsToAdd: T[], cache: EventsCache<any>) {
    // wipe off the existing events and add new events
    cache.events.splice(0, cache.events.length, ...eventsToAdd);
}
